/* Component Dependencies */
var printCloseActionTemplate = require('templates/printCloseAction.hbs');
var printCloseActionReviewChangesTemplate = require('templates/printCloseAction-reviewChanges.hbs');
var printCloseActionRewardsTemplate = require('templates/printCloseAction-rewards.hbs');
var printCloseActionPrintOnlyTemplate = require('templates/printCloseAction-printOnly.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({

  type: 'printCloseAction',

  template: {
    'printCloseAction': printCloseActionTemplate,
    'printCloseAction-reviewChanges': printCloseActionReviewChangesTemplate,
    'printCloseAction-rewards': printCloseActionRewardsTemplate,
    'printCloseAction-printOnly': printCloseActionPrintOnlyTemplate
  },

  bindEvents: function () {
    var _self = this;
    _self.$el.find('.js-print').on('click', _self.showPrintDialog);
    _self.$el.find('.js-close').on('click', _self.closeWindow);
  },

  /**
   * This function opens the browser print dialog
   * @param {Object} Event object is passed
   */
  showPrintDialog: function (event) {
    event.preventDefault();
    event.stopPropagation();
    window.print();
  },

  /**
   * This function is used to close browser window tab
   * @param {Object} Event object is passed
   */
  closeWindow: function (event) {
    event.preventDefault();
    event.stopPropagation();
    window.close();
  }

});
